<template>
  <div class="delivery-item-list">
    <modal-item-list-add-addition :used-ids="positions.additions" @add="onAddAddition"/>

    <div class="table-responsive">
      <table role="table" class="table b-table">
        <thead>
        <tr>
          <th v-for="header of tableHeader" :key="header.key"
              :class="typeof header.thClass !== 'undefined' ? header.thClass : ''">
            {{ header.label }}
          </th>
        </tr>
        </thead>
        <tbody>
        <!--          <tr v-for="(row, index) of tableItems" :key="`row-${index}`">-->
        <!--            <td v-for="header of tableHeader" :key="header.key" :class="typeof header.tdClass !== 'undefined' ? header.tdClass : ''">-->
        <!--              <b-button variant="danger" size="sm" title="Entfernen"-->
        <!--                        @click="() => row.type === 'article' ? removeArticle(row.id) : removeAddition(row.id)"-->
        <!--                        v-if="header.key === 'actions'">-->
        <!--                <font-awesome-icon icon="times"/>-->
        <!--              </b-button>-->
        <!--              <span v-else-if="typeof row[header.key] !== 'undefined'">-->
        <!--                {{ row[header.key] }}-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
<!--        <tr v-for="(row, index) of tableItems" :key="`row1-${index}`"><td>{{row.articleId}}</td></tr>-->
        <add-article-row v-for="(row, index) of tableItems" :key="`row1-${index}`" :value="row" :context="context"
                         :table-header="tableHeader" :seller="sellerFactory"
        @onRemove="onRemovePosition"
        @onChange="onUpdate"/>
        <!--          <add-article-row :context="context" :table-header="tableHeader" :seller="sellerFactory" @add="onAddArticle" :show-add="true"></add-article-row>-->
        </tbody>
      </table>
      <b-button class="mt-1 mr-3 float-right" size="sm" @click="onAddArticle" variant="success">
        <font-awesome-icon icon="plus"/>
      </b-button>
    </div>

    <div class="right">
      <b-button v-if="context==='piglet'" variant="primary" size="sm" v-b-modal.modal-add-addition :disabled="disabled">
        <font-awesome-icon icon="plus"/>
        Zu- / Abschläge hinzufügen
      </b-button>
    </div>
  </div>
</template>

<script>
import {ref, computed, watch} from '@vue/composition-api'
import SelectPigSty from "@/components/select-pig-sty/select-pig-sty.vue";
import ModalItemListAddAddition from "@/app/components/report/item-list/ModalItemListAddAddition.vue";
import AddArticleRow from "@/app/components/report/item-list/AddArticleRow.vue";

const uuid4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export default {
  components: {AddArticleRow, ModalItemListAddAddition, SelectPigSty},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    articles: {
      type: Array,
      default: () => ([])
    },
    additions: {
      type: Array,
      default: () => ([])
    },
    context: {
      type: String,
      required: true,
    },
    seller: {
      type: Object,
      default: () => {
      }
    }
  },

  emits: ['update'],

  setup(props, {emit}) {
    const store = window.useStore()

    const positions = ref({
      articles: props.articles.map(article => ({
        ...article,
        id: uuid4()
      })),
      additions: props.additions,
    })

    console.log("positions", positions);

    const sellerFactory = ref(props.seller);

    watch(() => props.additions, () => positions.value.additions = props.additions)
    watch(() => props.seller, () => {
      sellerFactory.value = props.seller;
    });

    const articles = computed(() => {
      return typeof store.state.pwa.deliveries[props.context] !== 'undefined'
        ? store.state.pwa.deliveries[props.context].config.article.data
        : []
    })
    const additions = computed(() => typeof store.state.pwa.deliveries.piglet !== 'undefined' ? store.state.pwa.deliveries.piglet.config['delivery-addition'].data : [])

    const getArticle = id => {
      const res = articles.value.filter(a => a.id === id)
      return res.length > 0 ? res.shift() : null
    }

    const getProducer = id => {
      const res = producers.value.filter(p => p.id === id)
      return res.length > 0 ? res.shift() : null
    }

    const buildName = (article) => {
      if (!article) {
        return null
      }
      return `${article.number ? `${article.number} - ` : ''}` + article.name
    }

    const producers = computed(() => {
      if (!store.state.pwa.pigSty.data.length) {
        return []
      }
      return store.state.pwa.pigSty.data.reduce((res, item) => {
        res.push(item)
        return res
      }, [])
    })

    const getProducerName = article => {
      const producer = getProducer(article.nativityId)

      if (!producer) {
        return null
      }

      return `${producer.name} ${producer.businessIdentifier.lfbis}`
    }

    const emitUpdate = () => {
      const data = {...positions.value}
      console.log("data", data);
      data.articles = data.articles.map(article => {
        if (article.articleId === null) {
          article.articleId = 0
        }
        return {
          ...article,
          id: '0'
        }
      })
      emit('update', data)
    }

    const onAddArticle = () => {
      const article = {
        articleId: null,
        article: '',
        id: uuid4(),
        pieces: 0,
        nativityId: 'AT',
        stateId: '6',
        nativityIdSty: 'AT',
        stateIdSty: '6',
        weight: 10,
        notice: null,
        lfbisSty: ''
      }
      positions.value.articles.push(article)
      emitUpdate()
    }

    const onRemovePosition= position => {
      console.log("remove", position);
      positions.value.articles = positions.value.articles.filter(article => article.id !== position.id)
      emitUpdate()
    }

    const onUpdate = position => {
      let article = positions.value.articles.find(article => article.id === position.id);
      const index = positions.value.articles.indexOf(article);
      positions.value.articles[index] = position;


      console.log("ppos", position);

      emitUpdate();
    }

    const onAddAddition = addition => {
      positions.value.additions.push(addition)
      emitUpdate()
    }

    const getAddition = id => {
      const res = additions.value.filter(addition => addition.id === id)
      if (res.length) {
        return res.shift()
      }
    }

    const getAdditionName = id => {
      const addition = getAddition(id)
      if (addition) {
        return addition.displayText
      }
    }

    const removeArticle = id => {
      positions.value.articles = positions.value.articles.filter(article => article.id !== id)
      emitUpdate()
    }

    const removeAddition = id => {
      positions.value.additions = positions.value.additions.filter(i => i !== id)
      emitUpdate()
    }

    const tableHeader = props.context === 'piglet' ? [
      {
        key: 'pieces',
        label: 'Stück',
        thClass: 'text-center',
        tdClass: 'text-center',
        tdStyle: 'min-width: 100px;width: 100px'
      },
      {key: 'name', label: 'Name'},
      {key: 'country', label: 'Land⁴', thClass: 'text-center', tdClass: 'text-center', tdStyle: 'min-width: 100px'},
      {key: 'weight', label: 'Gewicht', thClass: 'text-center', tdClass: 'text-center'},
      {key: 'notice', label: 'Nähere Angaben (z.B. Bio², offene Wartezeit⁵)'},
      {key: 'actions', label: ''},
    ] : [
      {
        key: 'pieces',
        label: 'Stück',
        thClass: 'text-center',
        tdClass: 'text-center',
        tdStyle: 'min-width: 100px;width: 100px'
      },
      {key: 'category', label: 'Kategorie', tdStyle: 'min-width: 200px'},
      {key: 'nativityId', label: 'Land⁴', thClass: 'text-center', tdClass: 'text-center', tdStyle: 'min-width: 100px'},
      {key: 'stateId', label: 'BL', thClass: 'text-center', tdClass: 'text-center', tdStyle: 'min-width: 80px'},
      {
        key: 'lfbisOrigin',
        label: 'LFBIS-Nr. Geburt',
        thClass: 'text-center',
        tdClass: 'text-center',
        tdStyle: 'min-width: 120px'
      },
      {
        key: 'nativityIdSty',
        label: 'Land⁴',
        thClass: 'text-center',
        tdClass: 'text-center',
        tdStyle: 'min-width: 100px'
      },
      {key: 'stateIdSty', label: 'BL', thClass: 'text-center', tdClass: 'text-center', tdStyle: 'min-width: 80px'},
      {
        key: 'lfbisSty',
        label: 'LFBIS-Nr. Mast',
        thClass: 'text-center',
        tdClass: 'text-center',
        tdStyle: 'min-width: 120px'
      },
      {key: 'notice', label: 'Nähere Angaben (z.B. Bio², offene Wartezeit⁵)', tdStyle: 'min-width: 150px'},
      {key: 'actions', label: ''},
    ]

    const tableItems = computed(() => ([
      ...positions.value.articles.map(item => {
        let name = item.text
        if (item.articleId) {
          const article = getArticle(item.articleId)
          if (article) {
            name = article.name
          }
        }
        console.log("item", item);
        return props.context === 'piglet' ? {
          type: 'article',
          id: item.id,
          articleId: item.articleId,
          pieces: item.pieces,
          name,
          country: item.nativityId,
          weight: item.weight,
          notice: item.notice,
        } : {
          type: 'article',
          id: item.id,
          articleId: item.articleId,
          pieces: item.pieces,
          category: `${item.text}`,
          lfbisOrigin: item.lfbisOrigin,
          lfbisSty: item.lfbisSty,
          weight: item.weight,
          notice: item.notice,
          nativityId: item.nativityId,
          nativityIdSty: item.nativityId,
          stateId: item.stateId,
          stateIdSty: item.stateIdSty
        }
      }),
      ...positions.value.additions.map(id => ({
        type: 'addition',
        id,
        pieces: '-',
        name: getAdditionName(id),
      }))
    ]))

    return {
      positions,
      producers,
      buildName,
      getArticle,
      getProducer,
      onAddArticle,
      onAddAddition,
      getProducerName,
      getAdditionName,
      removeArticle,
      removeAddition,
      sellerFactory,
      tableHeader,
      tableItems,
      onRemovePosition,
      onUpdate
    }
  }
}
</script>

<style lang="scss">
.delivery-item-list {
  ul {
    list-style-type: none;
    margin: 0 0 20px;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      width: 100%;
      text-decoration: none;
      color: #383838;
      margin: 7px 0;
      background: #f5f5f5;
      padding: 10px 16px;
      border-radius: 10px;

      .btn-wrap {
        float: right;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}
</style>
